import React from 'react';
import Style from './ProjectModal.module.scss';
import ImageGallery from './ImageGallery';
import TechBadge from './TechBadge';

export default function ProjectModal({ project, isOpen, onClose }) {
    if (!project || !isOpen) return null;

    return (
        <div className={`${Style.backdrop} ${isOpen ? Style.show : ''}`} onClick={onClose}>
            <div className={Style.modal} onClick={(e) => e.stopPropagation()}>
                {/* Close Button */}
                <button className={Style.closeBtn} onClick={onClose}>
                    ✕
                </button>

                {/* Modal Content */}
                <div className={Style.content}>
                    {/* Header */}
                    <div className={Style.header}>
                        <div>
                            <h2 className={Style.title}>{project.title}</h2>
                            <p className={Style.tagline}>{project.tagline}</p>
                        </div>
                        <span className={Style.badge}>{project.badge}</span>
                    </div>

                    {/* Image Gallery */}
                    <div className={Style.imageSection}>
                        <ImageGallery images={project.images} title={project.title} />
                    </div>

                    {/* Project Info Grid */}
                    <div className={Style.infoGrid}>
                        <div className={Style.infoBox}>
                            <span className={Style.label}>Year</span>
                            <span className={Style.value}>{project.year}</span>
                        </div>
                        <div className={Style.infoBox}>
                            <span className={Style.label}>Duration</span>
                            <span className={Style.value}>{project.duration}</span>
                        </div>
                        <div className={Style.infoBox}>
                            <span className={Style.label}>Category</span>
                            <span className={Style.value}>{project.category}</span>
                        </div>
                        <div className={Style.infoBox}>
                            <span className={Style.label}>Team Size</span>
                            <span className={Style.value}>{project.team}</span>
                        </div>
                    </div>

                    {/* Full Description */}
                    <div className={Style.section}>
                        <h3>Project Overview</h3>
                        <div className={Style.description}>
                            {project.fullDescription.split('\n').map((line, idx) => {
                                if (line.trim().startsWith('•')) {
                                    return (
                                        <div key={idx} className={Style.bulletPoint}>
                                            <span className={Style.bullet}>→</span>
                                            <span>{line.replace('•', '').trim()}</span>
                                        </div>
                                    );
                                }
                                return line.trim() ? (
                                    <p key={idx}>{line.trim()}</p>
                                ) : null;
                            })}
                        </div>
                    </div>

                    {/* Key Highlights */}
                    <div className={Style.section}>
                        <h3>Key Achievements</h3>
                        <div className={Style.highlightsGrid}>
                            {project.highlights.map((highlight, idx) => (
                                <div key={idx} className={Style.highlightCard}>
                                    <span className={Style.icon}>{highlight.icon}</span>
                                    <p>{highlight.text}</p>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Impact */}
                    <div className={Style.section}>
                        <h3>Business Impact</h3>
                        <div className={Style.impactBox}>
                            <p>{project.impact}</p>
                        </div>
                    </div>

                    {/* Tech Stack */}
                    <div className={Style.section}>
                        <h3>Technology Stack</h3>
                        <div className={Style.techStackGrid}>
                            {project.techStack.map((tech, idx) => (
                                <TechBadge
                                    key={idx}
                                    name={tech.name}
                                    category={tech.category}
                                />
                            ))}
                        </div>
                    </div>

                    {/* CTA */}
                    <div className={Style.ctaSection}>
                        <a
                            href="https://github.com/irfanbalghari"
                            target="_blank"
                            rel="noopener noreferrer"
                            className={Style.ctaButton}
                        >
                            View on GitHub →
                        </a>
                        <a
                            href="https://linkedin.com/in/irfanbalghari"
                            target="_blank"
                            rel="noopener noreferrer"
                            className={Style.ctaButtonSecondary}
                        >
                            Connect on LinkedIn
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}
